/*
 * Photo lightbox for sections/eb-cafe-space.
 *
 * Each gallery photo is a button carrying its full-size URL. Clicking one
 * opens a native <dialog> (modal: it traps focus, Esc closes it and focus
 * returns to the photo that opened it). Arrows, the arrow keys and a swipe
 * step through the photos; clicking the dark backdrop closes it.
 */

if (!customElements.get('eb-lightbox-gallery')) {
  customElements.define(
    'eb-lightbox-gallery',
    class EbLightboxGallery extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-lightbox-src]'));
        this.dialog = this.querySelector('.eb-lightbox');
        if (!this.dialog || !this.triggers.length) return;

        this.image = this.dialog.querySelector('.eb-lightbox__image');
        this.caption = this.dialog.querySelector('.eb-lightbox__caption');
        this.counter = this.dialog.querySelector('.eb-lightbox__counter');
        this.index = 0;

        this.triggers.forEach((trigger, i) => trigger.addEventListener('click', () => this.open(i)));
        this.dialog.querySelector('.eb-lightbox__close').addEventListener('click', () => this.dialog.close());
        this.dialog.querySelector('.eb-lightbox__prev').addEventListener('click', () => this.show(this.index - 1));
        this.dialog.querySelector('.eb-lightbox__next').addEventListener('click', () => this.show(this.index + 1));

        // A click on the backdrop lands on the dialog itself, not its content.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1);
          if (event.key === 'ArrowRight') this.show(this.index + 1);
        });

        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('eb-lightbox-open'));

        let startX = null;
        this.dialog.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
        this.dialog.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.show(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }

      open(i) {
        this.show(i);
        document.documentElement.classList.add('eb-lightbox-open');
        this.dialog.showModal();
      }

      show(i) {
        const count = this.triggers.length;
        this.index = (i + count) % count;
        const trigger = this.triggers[this.index];
        this.image.src = trigger.dataset.lightboxSrc;
        this.image.alt = trigger.dataset.lightboxAlt || '';
        this.caption.textContent = trigger.dataset.lightboxAlt || '';
        this.counter.textContent = `${this.index + 1} / ${count}`;
        // Warm the neighbours so stepping through feels instant.
        [this.index - 1, this.index + 1].forEach((n) => {
          new Image().src = this.triggers[(n + count) % count].dataset.lightboxSrc;
        });
      }
    }
  );
}
